/**
 * Instância global do QueryClient utilizada para gerenciar o cache e o estado das queries
 * em toda a aplicação React. Configurações padrão são aplicadas.
 *
 * @see {@link https://react-query.tanstack.com/reference/QueryClient}
 */

import { QueryClient } from 'react-query'

const queryClient = new QueryClient()

export { queryClient }
